import React from "react";
import { FaExclamationTriangle, FaRedo, FaHome } from "react-icons/fa";
import styles from "../../styles/components/common/AppErrorBoundary.module.css";
import {
  reloadOnceForChunkError,
  reloadPage,
  reportRenderError,
} from "../../utils/renderCrash";

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportRenderError(error, errorInfo, "AppErrorBoundary");
    reloadOnceForChunkError(error);
  }

  handleRetry = () => {
    reloadPage();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.container} role="alert">
          <div className={styles.card}>
            <div className={styles.icon}>
              <FaExclamationTriangle />
            </div>
            <h1 className={styles.title}>Something went wrong</h1>
            <p className={styles.message}>
              The app ran into an unexpected error. You can retry, or browse
              categories.
            </p>

            <div className={styles.actions}>
              <button
                type="button"
                onClick={this.handleRetry}
                className={styles.retryButton}
              >
                <FaRedo /> Try Again
              </button>
              <button
                type="button"
                onClick={this.handleGoHome}
                className={styles.homeButton}
              >
                <FaHome /> Browse Categories
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default AppErrorBoundary;
